import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  class: "py-2"
};
import { Sponsor } from "@/modules/sponsoring/entity";
import SponsorComponent from "@/modules/sponsoring/components/Sponsor.vue";
import { app } from "@/di";
import SponsoringHandler from "@/modules/sponsoring/services/SponsoringHandler";
import { Team } from "@/modules/team/entity";
import RichDialog from "@/modules/vue/components/RichDialog.vue";
import FinanceLayout from "@/modules/finances/pages/FinanceLayout.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  async setup(__props) {
    let __temp, __restore;
    const props = __props;
    const sponsors = ref([]);
    const {
      refresh
    } = ([__temp, __restore] = _withAsyncContext(async () => useInitial(async () => {
      sponsors.value = await Sponsor.find();
    })), __temp = await __temp, __restore(), __temp);
    const dialog = ref(null);
    const acceptedSponsor = computed(() => sponsors.value.find(s => s.accepted));
    const onAccept = async sponsor => {
      await dialog.value?.confirm();
      await app.get(SponsoringHandler).accept(sponsor, await Team.current());
      await refresh();
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(FinanceLayout, null, {
        title: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('sponsor_offers')), 1)]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.collect(sponsors.value).sortByDesc('accepted'), sponsor => {
          return _openBlock(), _createBlock(SponsorComponent, {
            key: sponsor.id,
            sponsor: sponsor,
            "can-be-accepted": !_unref(acceptedSponsor),
            muted: _unref(acceptedSponsor) && !sponsor.accepted,
            onAccept: $event => onAccept(sponsor)
          }, null, 8, ["sponsor", "can-be-accepted", "muted", "onAccept"]);
        }), 128))]), _createVNode(RichDialog, {
          ref_key: "dialog",
          ref: dialog,
          "confirmation-only": _ctx.$t('accept_sponsor_offer?')
        }, null, 8, ["confirmation-only"])]),
        _: 1
      });
    };
  }
});